/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type CrossWorkerDocsSynchronizeCreateRequest = {} | null | undefined;
export type CrossWorkerDocsSynchronizeCreateResponse = any;

export type CrossWorkerDocsSynchronizeCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/cross_worker_docs/{id}/synchronize/
 *
 * ```yaml
 * operationId: cross_worker_docs_synchronize_create
 * tags:
 *   - cross_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const crossWorkerDocsSynchronizeCreateOperation = ({
  id,
  ...rest
}: CrossWorkerDocsSynchronizeCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/cross_worker_docs/${id}/synchronize/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/cross_worker_docs/{id}/synchronize/' };
  };

/**
 * POST /dmx-server/cross_worker_docs/{id}/synchronize/
 *
 * ```yaml
 * operationId: cross_worker_docs_synchronize_create
 * tags:
 *   - cross_worker_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const crossWorkerDocsSynchronizeCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: CrossWorkerDocsSynchronizeCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = crossWorkerDocsSynchronizeCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
